jQuery(document).ready(function ($) {
  var currentCategoryId = 35;
  var currentCategoryPlayerId = 70;

  function loadPosts(categoryId, page) {
      $.ajax({
          url: site_ajax.url,
          type: 'POST',
          data: {
              action: 'filter_posts_by_category',
              nonce: site_ajax.nonce,
              category_id: categoryId,
              page: page,
          },
          beforeSend: function () {
              $('#testimony-content').html('<div id="loader"><div class="ball"></div><div class="ball2"></div><div class="ball3"></div></div>');
          },
          success: function (response) {
              $('#testimony-content').html(response.posts);
              $('.pagination').html(response.pagination);
          },
          error: function (xhr, status, error) {
              console.error(error);
              $('#testimony-content').html('<p>Erreur lors du chargement des articles.</p>');
          },
      });
  }

  // Handle category click
  $('.category-testimony').on('click', function (e) {
      e.preventDefault();
      if(!$(this).hasClass('tab-active')){
        $('.category-testimony').removeClass('tab-active');
        $(this).addClass('tab-active');
        currentCategoryId = $(this).data('category-id');
        loadPosts(currentCategoryId, 1);
      }
  });

  // Handle pagination click
  $(document).on('click', '.pagination-testimony a', function (e) {
      e.preventDefault();

      var page = $(this).data('page');
      loadPosts(currentCategoryId, page);
  });

  function loadBlogPosts(page) {
      $.ajax({
          url: site_ajax.url,
          type: 'POST',
          data: {
              action: 'filter_blog_posts',
              nonce: site_ajax.nonce,
              page: page,
          },
          beforeSend: function () {
              $('#blog-introduction .blog-posts').html('<div id="loader"><div class="ball"></div><div class="ball2"></div><div class="ball3"></div></div>');
          },
          success: function (response) {
              $('#blog-introduction .blog-posts').html(response.posts);
              $('#blog-introduction .pagination').html(response.pagination);
          },
          error: function (xhr, status, error) {
              console.error(error);
              $('#blog-introduction .blog-posts').html('<p>Erreur lors du chargement des articles.</p>');
          },
      });
  }

  // Handle pagination click
  $(document).on('click', '.pagination-blog a', function (e) {
    e.preventDefault();

    var page = $(this).data('page');
    loadBlogPosts(page);
  });

  function loadPlayers(categoryId, page) {
    $.ajax({
        url: site_ajax.url,
        type: 'POST',
        data: {
            action: 'filter_players_by_category',
            nonce: site_ajax.nonce,
            category_id: categoryId,
            page: page,
        },
        beforeSend: function () {
            $('#players-content').html('<div id="loader"><div class="ball"></div><div class="ball2"></div><div class="ball3"></div></div>');
        },
        success: function (response) {
            $('#players-content').html(response.posts);
            $('.pagination').html(response.pagination);
        },
        error: function (xhr, status, error) {
            console.error(error);
            $('#players-content').html('<p>Erreur lors du chargement des joueurs.</p>');
        },
    });
  }

  // Handle category click
  $('.category-player').on('click', function (e) {
      e.preventDefault();
      if(!$(this).hasClass('tab-active')){
        $('.category-player').removeClass('tab-active');
        $(this).addClass('tab-active');
        currentCategoryPlayerId = $(this).data('category-id');
        loadPlayers(currentCategoryPlayerId, 1);
      }
  });

  // Handle pagination click
  $(document).on('click', '.pagination-player a', function (e) {
      e.preventDefault();

      var page = $(this).data('page');
      loadPlayers(currentCategoryPlayerId, page);
  });
});
